import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { ApplyEscalationRequest, GetBulkPriceAgreementListRequest, GetBulkPriceSchemeListRequest, GetPriceEscalationHistoryRequest } from '../models/request/bulkPrice/BulkPriceRequests';

export class BulkPriceService {
    static async getSchemeList(inputObj: GetBulkPriceSchemeListRequest) {
        try {
            console.log('SERVICE CALL - GetBulkPriceSchemeListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BulkPrice/GetBulkPriceSchemeListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportSchemeList(inputObj: GetBulkPriceSchemeListRequest) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/BulkPrice/ExportBulkPriceSchemeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAgreementList(inputObj: GetBulkPriceAgreementListRequest) {
        try {
            console.log('SERVICE CALL - GetBulkPriceAgreementList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BulkPrice/GetBulkPriceAgreementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Kalem bazlı giriş için en son Eskalasyon Dağılımı ağırlıkları. */
    static async getCostItemWeights() {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/BulkPrice/GetEscalationCostItemWeights', {});

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Eskalasyonu kuyruğa alır. Fiyatlar kuyruktaki iş çalışınca güncellenir. */
    static async applyEscalation(inputObj: ApplyEscalationRequest) {
        try {
            console.log('SERVICE CALL - ApplyEscalation', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BulkPrice/ApplyEscalation', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getEscalationHistory(inputObj: GetPriceEscalationHistoryRequest) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/BulkPrice/GetPriceEscalationHistory', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAgreementList(inputObj: GetBulkPriceAgreementListRequest) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/BulkPrice/ExportBulkPriceAgreementList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}
